module.exports = __webpack_public_path__ + "img/bre4.3703774b.png";